import * as React from 'react';
import { Icon, iconName, IconSize } from '../icons/Icons';
import styled, { css } from 'styled-components';
import { amorgStyles } from '../styles/amorgStyles';

type ButtonRadioButtonProps = {
    id?:string,
    name:string,
    text:string,
    value:string,
    checked?:boolean,
    disabled?:boolean,
    leadingContent?:{
        icon:iconName,
        color:string,
        iconSize?:IconSize
    },
    trailingContent?:{
        icon:iconName,
        color:string,
        iconSize?:IconSize
    },
    hideBorder?: boolean
    onChange:(value:string)=>void
}

const iconWidth = '24px';

export function ButtonRadioButton(props:ButtonRadioButtonProps)
{
    return (
        <RadioWrapper>
            <RadioInput type="radio" 
                id={props.id} 
                name={props.name} 
                value={props.value} 
                checked={props.checked} 
                disabled={props.disabled} 
                onChange={() => props.onChange(props.value)} />
            
            <RadioLabel htmlFor={props.id}
                border={!props.hideBorder}
                checked={props.checked}
                disabled={props.disabled}>

                <span style={{width:iconWidth, flexGrow:0}}>
                    {props.leadingContent &&
                    <Icon name={props.leadingContent.icon} color={props.leadingContent.color} size={props.leadingContent.iconSize || 'small'} />
                    }
                </span>

                <span style={{flexGrow:1}}>
                    {props.text}
                </span>

                <span style={{width:iconWidth, flexGrow:0}}>
                    {props.trailingContent &&
                        <Icon name={props.trailingContent.icon} color={props.trailingContent.color} size={props.trailingContent.iconSize || 'small'} />
                    }
                </span>

            </RadioLabel>

            
        </RadioWrapper>
    );
}

const RadioWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    min-height: 56px;
`;

const RadioInput = styled.input`
    opacity: 0;
    position: fixed;
    width: 0;
   
`;

const RadioLabel = styled.label<{disabled:boolean, checked:boolean, border: boolean}>`
    display: flex;
    flex: 1;
    gap:6px;
    justify-content: space-between;
    align-items: center;
    padding: 16px 8px;
    font-family: sans-serif, Arial;
    font-size: 14px;
    white-space: nowrap;
    
    // Only apply disabled styling if not checked
    background-color: ${props => 
        props.checked 
            ? props.theme.colors.buttonRadioButton.backgroundSelected
            : props.disabled
                ? props.theme.colors.buttonRadioButton.backgroundDisabled
                : props.theme.colors.buttonRadioButton.background
    };
    color: ${props =>
        props.checked 
            ? props.theme.colors.buttonRadioButton.textHover
            : props.disabled                
                ? props.theme.colors.buttonRadioButton.textDisabled
                : props.theme.colors.buttonRadioButton.text
    };

    border-radius: ${props => amorgStyles(props.theme.colors).button2.borderRadius};
    border: ${props => props.border ? `1px solid ${props.theme.colors.buttonRadioButton.border}` : 'none'};

    ${props => !props.disabled  && css`
        :hover {
            cursor: pointer;
            background-color: ${props.theme.colors.buttonRadioButton.backgroundHover};
            color: ${props.theme.colors.buttonRadioButton.textHover};
    `}


`;